import { render } from "./Question.html?vue&type=template&id=615d528e&scoped=true&ts=true"
import script from "./Question.ts?vue&type=script&lang=ts"
export * from "./Question.ts?vue&type=script&lang=ts"

import "./Question.css?vue&type=style&index=0&id=615d528e&scoped=true&lang=css"

import exportComponent from "/home/dev/deployment/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615d528e"]])

export default __exports__